export const DEFAULT_PER_PAGE = 10;

// ページング情報の初期値を生成
export const createInitialPagination = (perPage = DEFAULT_PER_PAGE) => ({
  current_page: 1,
  total_pages: 1,
  total_count: 0,
  per_page: perPage,
});
